"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>ChatContent
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_pcln_icons_namespaceObject = require("pcln-icons");
const external_DialogLoading_js_namespaceObject = require("./DialogLoading.js");
const external_ScrollIntoView_js_namespaceObject = require("./ScrollIntoView.js");
const index_js_namespaceObject = require("./components/TryAgain/index.js");
var index_js_default = /*#__PURE__*/ __webpack_require__.n(index_js_namespaceObject);
const ChatbotDataContext_js_namespaceObject = require("./context/ChatbotDataContext.js");
const useDialogStylesContext_js_namespaceObject = require("./hooks/useDialogStylesContext.js");
const external_submitChatMessages_js_namespaceObject = require("./submitChatMessages.js");
const external_ChatContent_styles_js_namespaceObject = require("./ChatContent.styles.js");
const external_ChatMessagesCollections_js_namespaceObject = require("./ChatMessagesCollections.js");
const ChatInput_js_namespaceObject = require("./components/ChatInput/ChatInput.js");
const Loading_index_js_namespaceObject = require("./components/Loading/index.js");
var Loading_index_js_default = /*#__PURE__*/ __webpack_require__.n(Loading_index_js_namespaceObject);
const MetadataManager_js_namespaceObject = require("./components/MarkdownComponent/MetadataManager.js");
const PennyExpandableInput_index_js_namespaceObject = require("./components/PennyExpandableInput/index.js");
var PennyExpandableInput_index_js_default = /*#__PURE__*/ __webpack_require__.n(PennyExpandableInput_index_js_namespaceObject);
const StandaloneStyleContext_js_namespaceObject = require("./context/StandaloneStyleContext.js");
const useChatMessagesContext_js_namespaceObject = require("./hooks/useChatMessagesContext.js");
const useChatUIContext_js_namespaceObject = require("./hooks/useChatUIContext.js");
const useLoadingStateContext_js_namespaceObject = require("./hooks/useLoadingStateContext.js");
const useMarkerComponentMemo_js_namespaceObject = require("./hooks/useMarkerComponentMemo.js");
const ClearHistory_js_namespaceObject = require("./svgs/ClearHistory.js");
var ClearHistory_js_default = /*#__PURE__*/ __webpack_require__.n(ClearHistory_js_namespaceObject);
const browserStorage_js_namespaceObject = require("./utils/browserStorage.js");
const getLastUserMessage_js_namespaceObject = require("./utils/getLastUserMessage.js");
const removePennyInitialMessageKeys_js_namespaceObject = require("./utils/removePennyInitialMessageKeys.js");
const resolveChatContentVariables_js_namespaceObject = require("./utils/resolveChatContentVariables.js");
const EXPANDABLE_INPUT_INIT_HEIGHT = 30;
const GREETING_MESSAGE = "Hi, I'm Penny, your virtual travel assistant! How can I help you today?";
const TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_opener_logo_no_border_v1.1.svg';
const DUMMY_HELLO_MESSAGE = 'Hello!!!';
const SEPARATOR_MESSAGE = '<SEPARATOR>';
const ChatMainContentSection = ({ retrievalLoading = false, visibilityChannel })=>{
    const { setLoadMoreMessages, submitChatMessagesPayload, handleMarkerResponse, fetchRequestOptions, markerComponents, errorMessage, setErrorMessage, setIsDisablingInputValue, fullStreamingTexts, setStreamingText, debugMode, discoveryCitySelected, pushPrompt, loadMoreMessages, isDisablingInput, accountLessAccessToken, accountLessTripsAccessPayload, setiValues } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    if (accountLessTripsAccessPayload) submitChatMessagesPayload.accountLessTripsAccessPayload = accountLessTripsAccessPayload;
    const memoMarkerComponents = (0, useMarkerComponentMemo_js_namespaceObject.useMarkerComponentMemo)(markerComponents);
    const { chatMessages, setChatMessages } = (0, useChatMessagesContext_js_namespaceObject.useChatMessagesContext)();
    const { openErrorComponent, setOpenErrorComponent } = (0, useChatUIContext_js_namespaceObject.useChatUIContext)();
    const [expandableTextHeight, setExpandableTextHeight] = (0, external_react_namespaceObject.useState)(EXPANDABLE_INPUT_INIT_HEIGHT);
    const { isLoading, setLoadingStatus, loadingStatusMessages, setLoadingStatusMessage } = (0, useLoadingStateContext_js_namespaceObject.useLoadingStateContext)();
    const contentRef = (0, external_react_namespaceObject.useRef)(null);
    const messagesEndRef = (0, external_react_namespaceObject.useRef)(null);
    const loadRef = (0, external_react_namespaceObject.useRef)(null);
    const [lastMessage, setLastMessage] = (0, external_react_namespaceObject.useState)('');
    const [showClearedHistory, setShowClearedHistory] = (0, external_react_namespaceObject.useState)(false);
    const [isClearedHistoryActive, setIsClearedHistoryActive] = (0, external_react_namespaceObject.useState)(false);
    const [currScrollHeight, setCurrScrollHeight] = (0, external_react_namespaceObject.useState)(0);
    const { isSessionActive, hotelPayload, productId } = submitChatMessagesPayload;
    const isAudioPlaybackEnabledRef = (0, external_react_namespaceObject.useRef)(false);
    const { isShowMoreListingCards = false } = hotelPayload ?? {};
    const { isExpandedInput } = setiValues ?? {};
    const handleExpandableInputHeight = (0, external_react_namespaceObject.useCallback)((height)=>{
        setExpandableTextHeight(height);
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (chatMessages) {
            const userMessage = (0, getLastUserMessage_js_namespaceObject.getLastUserMessage)(chatMessages);
            if (userMessage) setLastMessage(userMessage.content);
        }
    }, [
        chatMessages.length
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (messagesEndRef.current) messagesEndRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    }, [
        expandableTextHeight
    ]);
    const submitChatMessagesOptions = {
        setChatMessages,
        setStreamingText,
        setLoadingStatus,
        setErrorMessage,
        setIsDisablingInputValue,
        requestOptions: {
            ...fetchRequestOptions,
            headers: {
                ...fetchRequestOptions?.headers,
                ...accountLessAccessToken ? {
                    'account-less-access-token': accountLessAccessToken
                } : {}
            }
        },
        markerComponents,
        handleMarkerResponse,
        setLoadingStatusMessage
    };
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (discoveryCitySelected || pushPrompt && !retrievalLoading) {
            const chatContent = discoveryCitySelected ? `Looking for hotels in ${discoveryCitySelected}` : pushPrompt;
            const chatMessage = {
                content: chatContent,
                date: new Date(),
                role: 'user'
            };
            const promptMessage = {
                content: chatContent,
                role: 'user'
            };
            const updatedChatMessages = [
                ...chatMessages,
                chatMessage
            ];
            setChatMessages(updatedChatMessages);
            (0, external_submitChatMessages_js_namespaceObject.submitChatMessages)({
                submitChatMessagesPayload: {
                    ...submitChatMessagesPayload,
                    includeSpeech: isAudioPlaybackEnabledRef.current,
                    prompts: [
                        promptMessage
                    ]
                },
                setOpenErrorComponent,
                chatMessages: updatedChatMessages,
                ...submitChatMessagesOptions,
                requestOptions: {
                    ...submitChatMessagesOptions.requestOptions,
                    headers: {
                        ...submitChatMessagesOptions.requestOptions.headers,
                        ...accountLessAccessToken ? {
                            'account-less-access-token': accountLessAccessToken
                        } : {}
                    }
                }
            });
        }
    }, [
        discoveryCitySelected,
        pushPrompt
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        const onScroll = ()=>{
            const scrollableDiv = contentRef.current;
            if (!scrollableDiv) return;
        };
        if (contentRef.current) contentRef.current.addEventListener('scroll', onScroll);
        return ()=>{
            if (contentRef.current) contentRef.current.removeEventListener('scroll', onScroll);
        };
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        const curHeight = contentRef?.current?.scrollHeight;
        if (contentRef.current) contentRef.current.scrollTop = curHeight - currScrollHeight;
    }, [
        loadMoreMessages
    ]);
    const userMessages = (0, external_react_namespaceObject.useMemo)(()=>chatMessages?.filter((message)=>message?.role === 'user' && message?.content) ?? [], [
        chatMessages
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        const submitChatMessagePayloadObj = {
            setOpenErrorComponent,
            chatMessages,
            ...submitChatMessagesOptions,
            requestOptions: {
                ...submitChatMessagesOptions.requestOptions,
                headers: {
                    ...submitChatMessagesOptions.requestOptions.headers,
                    ...accountLessAccessToken ? {
                        'account-less-access-token': accountLessAccessToken
                    } : {}
                }
            }
        };
        const isNewMessageWithSession = !browserStorage_js_namespaceObject.browserStorageManager.getBrowserStorage()?.isInitialMessageSubmitted() && !retrievalLoading || chatMessages?.length === 1 && chatMessages?.[0]?.displayComponentName === 'SESSION_INITIALIZED';
        if (isNewMessageWithSession && !pushPrompt && -1 !== submitChatMessagesPayload.productId) {
            browserStorage_js_namespaceObject.browserStorageManager.getBrowserStorage()?.setInitialMessageSubmitted();
            (0, external_submitChatMessages_js_namespaceObject.submitChatMessages)({
                submitChatMessagesPayload: {
                    ...submitChatMessagesPayload,
                    prompts: [
                        {
                            role: 'user',
                            content: DUMMY_HELLO_MESSAGE
                        }
                    ]
                },
                ...submitChatMessagePayloadObj
            });
        }
    }, [
        retrievalLoading
    ]);
    const previousErrorState = (0, external_react_namespaceObject.useRef)(openErrorComponent);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (previousErrorState.current === openErrorComponent) return;
        previousErrorState.current = openErrorComponent;
        const curHeight = contentRef?.current?.scrollHeight;
        setIsDisablingInputValue(openErrorComponent && !isDisablingInput);
        if (chatMessages?.length > 0 && chatMessages[chatMessages.length - 1]?.role === 'user') {
            const userMessage = (0, getLastUserMessage_js_namespaceObject.getLastUserMessage)(chatMessages);
            if (userMessage) (0, external_submitChatMessages_js_namespaceObject.submitChatMessages)({
                submitChatMessagesPayload: {
                    ...submitChatMessagesPayload,
                    prompts: [
                        userMessage
                    ],
                    includeSpeech: false
                },
                setOpenErrorComponent,
                chatMessages,
                ...submitChatMessagesOptions,
                requestOptions: {
                    ...submitChatMessagesOptions.requestOptions,
                    headers: {
                        ...submitChatMessagesOptions.requestOptions.headers,
                        ...accountLessAccessToken ? {
                            'account-less-access-token': accountLessAccessToken
                        } : {}
                    }
                }
            });
            if (contentRef.current) contentRef.current.scrollTop = curHeight - currScrollHeight;
        }
    }, [
        openErrorComponent
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (!isLoading && isClearedHistoryActive && !showClearedHistory) {
            setShowClearedHistory(true);
            setTimeout(()=>{
                setIsClearedHistoryActive(false);
                setShowClearedHistory(false);
            }, 1000);
        }
    }, [
        isClearedHistoryActive
    ]);
    const handleViewHistory = (0, external_react_namespaceObject.useCallback)(()=>{
        setLoadMoreMessages(true);
        setCurrScrollHeight(contentRef?.current?.scrollHeight);
    }, []);
    const handleClearHistoryClick = (0, external_react_namespaceObject.useCallback)(()=>{
        handleClearHistory();
        setLoadMoreMessages(true);
    }, [
        handleClearHistory
    ]);
    function submitChatMessageInMarkerComponent(msg, updatedChatMessage, headers) {
        if (!msg.content && msg.displayComponentName) setChatMessages([
            ...chatMessages,
            msg
        ]);
        else (0, external_submitChatMessages_js_namespaceObject.submitChatMessages)({
            submitChatMessagesPayload: {
                ...submitChatMessagesPayload,
                prompts: [
                    msg
                ]
            },
            setOpenErrorComponent,
            chatMessages: Array.isArray(updatedChatMessage) && 0 !== updatedChatMessage.length ? updatedChatMessage : chatMessages,
            ...submitChatMessagesOptions,
            requestOptions: {
                ...submitChatMessagesOptions.requestOptions,
                headers: {
                    ...submitChatMessagesOptions.requestOptions.headers,
                    ...headers || {}
                }
            }
        });
    }
    function handleClearHistory() {
        const submitChatMessagePayloadObj = {
            setOpenErrorComponent,
            chatMessages: [],
            ...submitChatMessagesOptions,
            requestOptions: {
                ...submitChatMessagesOptions.requestOptions,
                headers: {
                    ...submitChatMessagesOptions.requestOptions.headers,
                    ...accountLessAccessToken ? {
                        'account-less-access-token': accountLessAccessToken
                    } : {}
                }
            }
        };
        browserStorage_js_namespaceObject.browserStorageManager.getBrowserStorage()?.removeItem('pennysid');
        (0, removePennyInitialMessageKeys_js_namespaceObject.removePennyInitialMessageKeys)();
        setChatMessages([]);
        setIsClearedHistoryActive(true);
        MetadataManager_js_namespaceObject.inlineMetadataManager.reset();
        (0, external_submitChatMessages_js_namespaceObject.submitChatMessages)({
            submitChatMessagesPayload: {
                ...submitChatMessagesPayload,
                prompts: [
                    {
                        role: 'user',
                        content: DUMMY_HELLO_MESSAGE
                    }
                ]
            },
            ...submitChatMessagePayloadObj
        });
    }
    const dialogStyles = (0, useDialogStylesContext_js_namespaceObject.useDialogStylesContext)();
    const standaloneStyles = (0, StandaloneStyleContext_js_namespaceObject.useStandaloneStyles)();
    const isDialogStylesEmpty = !dialogStyles?.topLevelBoxStyle || 0 === Object.keys(dialogStyles.topLevelBoxStyle).length;
    const styles = (0, resolveChatContentVariables_js_namespaceObject.resolveChatContentStyle)({
        isDialogStylesEmpty,
        dialogStyles,
        standaloneStyles
    });
    const excludedFirstMessages = [
        GREETING_MESSAGE,
        SEPARATOR_MESSAGE
    ];
    const shouldLoadMorePrompts = -1 === productId || !loadMoreMessages && isSessionActive && !excludedFirstMessages.includes(chatMessages?.[0]?.content) && chatMessages?.[0]?.displayComponentName !== 'SESSION_INITIALIZED';
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            retrievalLoading && isSessionActive ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Loading_index_js_default(), {}) : /*#__PURE__*/ (0, external_react_namespaceObject.createElement)(external_pcln_design_system_namespaceObject.Box, {
                ...styles.topLevelBoxStyle,
                height: (0, resolveChatContentVariables_js_namespaceObject.resolveChatContentHeight)({
                    isDialogStylesEmpty,
                    isExpandedInput,
                    expandableTextHeight
                }),
                key: "chat-dialog-transcript-container",
                ref: contentRef,
                children: [
                    showClearedHistory ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ChatContent_styles_js_namespaceObject.ToastWrapper, {
                        width: '300px',
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Toast, {
                            color: "success",
                            colorScheme: "successLight",
                            icon: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.SuccessOutline, {}),
                            hideClose: true,
                            children: "Chat History Cleared"
                        })
                    }) : null,
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                        ...styles.contentFlexStyle,
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_ChatContent_styles_js_namespaceObject.ChatHistoryControlWrapper, {
                                ref: loadRef,
                                children: [
                                    shouldLoadMorePrompts && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ChatContent_styles_js_namespaceObject.ChatHistoryControl, {
                                        onClick: handleViewHistory,
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Button, {
                                            variation: 'link',
                                            children: [
                                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.History, {
                                                    size: 20,
                                                    mr: 2
                                                }),
                                                " View History"
                                            ]
                                        })
                                    }),
                                    isSessionActive && userMessages?.length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ChatContent_styles_js_namespaceObject.ChatHistoryControl, {
                                        onClick: handleClearHistoryClick,
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Button, {
                                            variation: 'link',
                                            ml: 4,
                                            children: [
                                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ClearHistory_js_default(), {
                                                    size: 15
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                    ml: 2,
                                                    children: "Clear History"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                                justifyContent: 'center',
                                children: loadMoreMessages ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                    mb: 4,
                                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Spinner, {
                                        size: 40,
                                        color: 'purple',
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Image, {
                                            src: TRAVEL_BOT_LOGO,
                                            width: 28,
                                            alt: "Penny chat avatar"
                                        })
                                    })
                                }) : null
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ChatMessagesCollections_js_namespaceObject.ChatMessagesList, {
                                messagesEndRef: messagesEndRef,
                                isStandalone: isDialogStylesEmpty,
                                chatMessages: chatMessages,
                                markerComponents: memoMarkerComponents,
                                isLoading: isLoading,
                                debugMode: debugMode,
                                setIsDisablingInputValue: setIsDisablingInputValue,
                                setChatMessages: setChatMessages,
                                submitMessages: submitChatMessageInMarkerComponent,
                                submitChatMessageInMarkerComponent: submitChatMessageInMarkerComponent,
                                isShowMoreListingCards: isShowMoreListingCards,
                                submitQuickActionMessage: function(action) {
                                    const { chatContent, promptContent } = action;
                                    const promptMessage = {
                                        content: promptContent || chatContent,
                                        role: 'user'
                                    };
                                    const chatMessage = {
                                        content: chatContent,
                                        role: 'user'
                                    };
                                    const updatedChatMessages = [
                                        ...chatMessages,
                                        chatMessage
                                    ];
                                    setChatMessages(updatedChatMessages);
                                    (0, external_submitChatMessages_js_namespaceObject.submitChatMessages)({
                                        submitChatMessagesPayload: {
                                            ...submitChatMessagesPayload,
                                            prompts: [
                                                promptMessage
                                            ]
                                        },
                                        setOpenErrorComponent,
                                        chatMessages: updatedChatMessages,
                                        ...submitChatMessagesOptions,
                                        requestOptions: {
                                            ...submitChatMessagesOptions.requestOptions,
                                            headers: {
                                                ...submitChatMessagesOptions.requestOptions.headers,
                                                ...accountLessAccessToken ? {
                                                    'account-less-access-token': accountLessAccessToken
                                                } : {}
                                            }
                                        }
                                    });
                                },
                                clearActionsData: function() {
                                    setChatMessages(chatMessages.filter((msg)=>'STRUCTURED_DATA' !== msg.displayComponentName));
                                },
                                shouldEnableClientMarkdownParsing: setiValues?.shouldEnableClientMarkdownParsing
                            }),
                            errorMessage && openErrorComponent && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ScrollIntoView_js_namespaceObject.ScrollIntoView, {
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_js_default(), {
                                    lastMessage: lastMessage
                                })
                            }),
                            !isAudioPlaybackEnabledRef.current && isLoading && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ScrollIntoView_js_namespaceObject.ScrollIntoView, {
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_DialogLoading_js_namespaceObject.DialogLoading, {
                                    streamingText: fullStreamingTexts,
                                    lastMessage: lastMessage,
                                    loadingStatusMessages: loadingStatusMessages,
                                    shouldEnableClientMarkdownParsing: setiValues?.shouldEnableClientMarkdownParsing
                                })
                            })
                        ]
                    }),
                    isDialogStylesEmpty || isExpandedInput ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        ref: messagesEndRef,
                        style: {
                            height: 0
                        }
                    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {})
                ]
            }),
            isExpandedInput ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(PennyExpandableInput_index_js_default(), {
                setiValues: setiValues,
                submitChatMessagesOptions: submitChatMessagesOptions,
                styles: styles,
                handleExpandableInputHeight: handleExpandableInputHeight
            }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatInput_js_namespaceObject.ChatInput, {
                showToolTip: isDialogStylesEmpty,
                styles: styles,
                isAudioPlaybackEnabledRef: isAudioPlaybackEnabledRef,
                submitChatMessagesOptions: submitChatMessagesOptions,
                visibilityChannel: visibilityChannel
            })
        ]
    });
};
const ChatContent = /*#__PURE__*/ external_react_default().memo(ChatMainContentSection);
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
